import { Cell } from "@ton/core";
import { Buffer } from "node:buffer";

export function getTxHashFromBocString(boc: string) {
  const cells = Cell.fromBoc(Buffer.from(boc, "base64"));
  return Buffer.from(cells[0].hash()).toString("base64");
}
